import { DrawerSizes } from './types';

export const DRAWER_SIZES: DrawerSizes = {
  XLARGE: 'xlarge',
  LARGE: 'large',
  MEDIUM: 'medium',
  SMALL: 'small',
};
